/**
 * src/pages/OriginAndBeyond/sections/EvidenceSection.tsx
 * Section 4: Evidence key section:
 * - EvidenceKey component
 * - Short explanation "How to read this journey" (3 cards: labels on every claim, sources at the end of each page, beliefs are respected not ranked)
 */

import React from "react";
import { BadgeAlert, BookOpen, Compass, ShieldCheck } from "lucide-react";
import { EvidenceKey } from "@/components/originBeyond/EvidenceKey";
import { HOW_TO_READ_CARDS } from "../originAndBeyondData";
import "@/components/cosmic/cosmic.css";
export function EvidenceSection() {
  return <section id="evidence-key-section" className="w-full max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16 scroll-mt-20" aria-labelledby="evidence-section-heading">
      <div className="text-center max-w-2xl mx-auto mb-10">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-primary/20 bg-primary/5 text-primary text-xs font-mono mb-3">
          <ShieldCheck className="size-3.5" aria-hidden="true" />
          <span>EPISTEMOLOGICAL FRAMEWORK</span>
        </div>
        <h2 id="evidence-section-heading" className="font-serif text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-foreground mb-3">
          How to Read This Journey
        </h2>
        <p className="text-sm sm:text-base text-muted-foreground font-sans leading-relaxed">
          Exploring deep questions demands clarity about what is known, what is debated, and what
          transcends empirical measurement.
        </p>
      </div>

      {/* 3 "How to read this journey" guide cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-10">
        {HOW_TO_READ_CARDS.map((card, idx) => {
        const Icon = card.iconName === "badge" ? BadgeAlert : card.iconName === "book" ? BookOpen : Compass;
        return <div key={idx} className="ql-glass p-5 sm:p-6 rounded-xl border border-border/60 flex flex-col gap-3 min-w-0">
              <div className="size-10 rounded-lg border border-primary/30 bg-primary/10 flex items-center justify-center text-primary shrink-0">
                <Icon className="size-5" aria-hidden="true" />
              </div>
              <h3 className="font-serif text-base font-bold text-foreground tracking-wide">
                {card.title}
              </h3>
              <p className="text-xs sm:text-sm text-muted-foreground leading-relaxed font-sans">
                {card.description}
              </p>
            </div>;
      })}
      </div>

      {/* Shared EvidenceKey component */}
      <EvidenceKey title="Epistemological Evidence Tiers" className="rounded-2xl border border-border/80 shadow-[0_12px_36px_-10px_rgba(0,0,0,0.7)]" />
    </section>;
}